
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, submenuPageId }) => {

  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo"));
  const permissions = adminInfo?.permission || [];

  const allowedPageIds = permissions.map(p => p.submenuPageId);
  const hasAccess = allowedPageIds.includes(submenuPageId);

  return hasAccess ? children : <Navigate to="/not-authorized" replace />;
  
};

export default ProtectedRoute;
